import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card d-block" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "text-lg-right" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_6 = { class: "row mx-n2" }
const _hoisted_7 = { class: "col-md-4 mb-2 px-2" }
const _hoisted_8 = { class: "card d-block h-100" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "company-logo-holder border p-2" }
const _hoisted_11 = { class: "company-info-wrap" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fa fa-phone-alt" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_14 = { class: "my-3" }
const _hoisted_15 = { class: "col-md-8 mb-2 px-2" }
const _hoisted_16 = { class: "card d-block h-100" }
const _hoisted_17 = { class: "card-head pb-3" }
const _hoisted_18 = { class: "card-title" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "block-items my-2" }
const _hoisted_21 = { class: "row my-3" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "iconed-holder d-flex mt-2" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_25 = { class: "desc-wrap w-100" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_28 = { class: "desc-wrap" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "to-upper" }, "No. of days for this project", -1)
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_32 = { class: "desc-wrap" }
const _hoisted_33 = /*#__PURE__*/_createVNode("p", null, "Project Timeline", -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createVNode("strong", null, "TBD", -1)
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/_createVNode("strong", null, "-", -1)
const _hoisted_39 = { class: "mt-3" }
const _hoisted_40 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_41 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_42 = {
  key: 2,
  class: "badge badge-success"
}
const _hoisted_43 = {
  key: 3,
  class: "badge badge-danger"
}
const _hoisted_44 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = { class: "uppercase-text" }
const _hoisted_47 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_48 = { class: "card d-block mt-2" }
const _hoisted_49 = { class: "card-head pb-3" }
const _hoisted_50 = { class: "card-title" }
const _hoisted_51 = { class: "row my-3" }
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = { class: "iconed-holder d-flex mt-2" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_55 = { class: "desc-wrap w-100" }
const _hoisted_56 = { class: "col-md-4" }
const _hoisted_57 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_58 = { class: "desc-wrap" }
const _hoisted_59 = /*#__PURE__*/_createVNode("p", { class: "to-upper" }, "No. of days for this phase", -1)
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_62 = { class: "desc-wrap" }
const _hoisted_63 = /*#__PURE__*/_createVNode("p", null, "Phase Timeline", -1)
const _hoisted_64 = { key: 0 }
const _hoisted_65 = /*#__PURE__*/_createVNode("strong", null, "TBD", -1)
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { key: 2 }
const _hoisted_68 = /*#__PURE__*/_createVNode("strong", null, "-", -1)
const _hoisted_69 = { class: "my-4" }
const _hoisted_70 = {
  key: 0,
  class: "border rounded bg-light p-3 mt-2 pb-0"
}
const _hoisted_71 = { class: "row align-items-center mb-2" }
const _hoisted_72 = { class: "col-sm-6" }
const _hoisted_73 = { class: "form-check form-check-inline mb-2" }
const _hoisted_74 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_75 = { class: "members-list pt-sm-0 text-sm-right" }
const _hoisted_76 = { class: "row my-1" }
const _hoisted_77 = { class: "col-md-4" }
const _hoisted_78 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_80 = { class: "desc-wrap" }
const _hoisted_81 = { class: "row mt-2 align-items-start" }
const _hoisted_82 = { class: "col-md-5" }
const _hoisted_83 = { class: "col-md-4" }
const _hoisted_84 = { class: "iconed-holder d-flex align-items-center" }
const _hoisted_85 = { class: "desc-wrap" }
const _hoisted_86 = /*#__PURE__*/_createVNode("p", { class: "to-upper" }, [
  /*#__PURE__*/_createVNode("strong", null, "No. of days for this task:")
], -1)
const _hoisted_87 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_88 = { class: "form-check mt-2" }
const _hoisted_89 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "excludeWeekends"
}, " Exclude Weekends ", -1)
const _hoisted_90 = { class: "mt-2" }
const _hoisted_91 = {
  key: 0,
  class: "list-accordion mt-2"
}
const _hoisted_92 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_93 = { class: "mb-0" }
const _hoisted_94 = { class: "card-body p-2" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-md-6" }
const _hoisted_97 = { class: "col-md-6" }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = {
  key: 2,
  class: "image-in-chat preview-image-list"
}
const _hoisted_100 = { class: "row mx-n2" }
const _hoisted_101 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_102 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_103 = { class: "sr-only" }
const _hoisted_104 = { class: "imaged-col" }
const _hoisted_105 = { class: "small-img-wrap" }
const _hoisted_106 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_107 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_108 = { class: "sr-only" }
const _hoisted_109 = { class: "imaged-col" }
const _hoisted_110 = { class: "small-img-wrap" }
const _hoisted_111 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_112 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_113 = { class: "sr-only" }
const _hoisted_114 = { class: "imaged-col" }
const _hoisted_115 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_116 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_117 = { class: "centered-wrap" }
const _hoisted_118 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_119 = { class: "sr-only" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { class: "image-in-chat" }
const _hoisted_122 = { class: "image-box" }
const _hoisted_123 = { class: "image-wrapp" }
const _hoisted_124 = { class: "same-ht-img" }
const _hoisted_125 = { class: "file-name bg-light p-2" }
const _hoisted_126 = { class: "font-weight-bold" }
const _hoisted_127 = { class: "card d-block mt-3" }
const _hoisted_128 = { class: "card-head pb-3" }
const _hoisted_129 = { class: "card-title" }
const _hoisted_130 = { class: "row mx-n2" }
const _hoisted_131 = { class: "col-md-4 px-2" }
const _hoisted_132 = { class: "shadowed-card bg-light mt-2" }
const _hoisted_133 = { class: "mb-3" }
const _hoisted_134 = {
  "data-toggle": "modal",
  "data-target": "#documentModal",
  class: "btn default-btn me-2"
}
const _hoisted_135 = { class: "col-md-4 px-2" }
const _hoisted_136 = { class: "shadowed-card bg-light mt-2" }
const _hoisted_137 = { class: "mb-3" }
const _hoisted_138 = {
  "data-toggle": "modal",
  "data-target": "#documentModal1",
  class: "btn default-btn me-2"
}
const _hoisted_139 = { class: "card d-block mt-3" }
const _hoisted_140 = { class: "card-head pb-3" }
const _hoisted_141 = { class: "card-title" }
const _hoisted_142 = { class: "row" }
const _hoisted_143 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_144 = { class: "signature-wrap my-2" }
const _hoisted_145 = { class: "signature-wrap my-2" }
const _hoisted_146 = { class: "to-upper" }
const _hoisted_147 = {
  key: 0,
  class: "my-4 text-end"
}
const _hoisted_148 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_149 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_150 = {
  class: "modal fade",
  id: "documentModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_151 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_152 = { class: "modal-content" }
const _hoisted_153 = { class: "modal-header" }
const _hoisted_154 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_155 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_156 = { class: "modal-body" }
const _hoisted_157 = { class: "card contract-desc" }
const _hoisted_158 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_159 = {
  class: "modal fade",
  id: "documentModal1",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_160 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_161 = { class: "modal-content" }
const _hoisted_162 = { class: "modal-header" }
const _hoisted_163 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_164 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_165 = { class: "modal-body" }
const _hoisted_166 = { class: "card contract-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToSmartContract()))
            }, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('go_back')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("img", {
                src: _ctx.state.data.smartContractDtail.logo,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("p", null, [
                _createVNode("strong", null, _toDisplayString(_ctx.state.data.companyInfo.company_name), 1)
              ]),
              _createVNode("p", null, [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_phone_number), 1)
              ])
            ])
          ]),
          _hoisted_13,
          _createVNode("p", null, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('email_address')) + ":", 1)
          ]),
          _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_email), 1),
          _createVNode("div", _hoisted_14, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('company_address')) + ":", 1)
            ]),
            _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("h1", _hoisted_18, _toDisplayString(_ctx.$t('project_details')), 1)
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_emails')), 1)
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("ul", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.smartContractDtail.customers, (customer, customerIndex) => {
                  return (_openBlock(), _createBlock("li", { key: customerIndex }, _toDisplayString(customer.email || customer.mobile_number), 1))
                }), 128))
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode("div", _hoisted_25, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.state.data.smartContractDtail.budget), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.calculateProjectTotalDays(_ctx.state.data.phases)), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    (_ctx.state.data.projectTimeline.type == 4)
                      ? (_openBlock(), _createBlock("p", _hoisted_34, [
                          _hoisted_35
                        ]))
                      : (_ctx.state.data.projectTimeline?.start_date && _ctx.state.data.projectTimeline?.end_date)
                        ? (_openBlock(), _createBlock("p", _hoisted_36, [
                            _createVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.state.data.projectTimeline.start_date)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.state.data.projectTimeline.end_date)), 1)
                          ]))
                        : (_openBlock(), _createBlock("p", _hoisted_37, [
                            _hoisted_38
                          ]))
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_39, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('status')), 1)
            ]),
            (_ctx.state.data.smartContractDtail.status == 0)
              ? (_openBlock(), _createBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('draft')), 1))
              : _createCommentVNode("", true),
            (_ctx.state.data.smartContractDtail.status == 1)
              ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('sent')), 1))
              : _createCommentVNode("", true),
            (_ctx.state.data.smartContractDtail.status == 2)
              ? (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(_ctx.$t('approved')), 1))
              : _createCommentVNode("", true),
            (_ctx.state.data.smartContractDtail.status == 3)
              ? (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('declined')), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.state.data.smartContractDtail.declined_customers && _ctx.state.data.smartContractDtail.declined_customers.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_44, [
                _createVNode("p", _hoisted_45, [
                  _createVNode("strong", _hoisted_46, _toDisplayString(_ctx.$t('declined_reason')) + ": ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.state.data.smartContractDtail.declined_customers[0].reason), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.smartContractDtail.edoc_id)
            ? (_openBlock(), _createBlock("div", _hoisted_47, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('edoc_link')), 1)
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.state.data.smartContractDtail.edoc_id), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_48, [
      _createVNode("div", _hoisted_49, [
        _createVNode("h1", _hoisted_50, _toDisplayString(_ctx.$t('phases')), 1)
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.phases, (phase, phaseIndex) => {
        return (_openBlock(), _createBlock("div", {
          class: "shadowed-card mb-3",
          key: phaseIndex
        }, [
          _createVNode("p", null, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_name')) + " : ", 1),
            _createTextVNode(_toDisplayString(phase.name), 1)
          ]),
          _createVNode("div", _hoisted_51, [
            _createVNode("div", _hoisted_52, [
              _createVNode("div", _hoisted_53, [
                _hoisted_54,
                _createVNode("div", _hoisted_55, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(phase.budget), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_56, [
              _createVNode("div", _hoisted_57, [
                _createVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.getPhaseTotalDays(phase)), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_60, [
              _createVNode("div", _hoisted_61, [
                _createVNode("div", _hoisted_62, [
                  _hoisted_63,
                  (phase?.time_line?.type == 4)
                    ? (_openBlock(), _createBlock("p", _hoisted_64, [
                        _hoisted_65
                      ]))
                    : (phase?.time_line?.start_date && phase?.time_line?.end_date)
                      ? (_openBlock(), _createBlock("p", _hoisted_66, [
                          _createVNode("strong", null, _toDisplayString(_ctx.formatDate(phase.time_line.start_date)) + " - " + _toDisplayString(_ctx.formatDate(phase.time_line.end_date)), 1)
                        ]))
                      : (_openBlock(), _createBlock("p", _hoisted_67, [
                          _hoisted_68
                        ]))
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_69, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_description')) + " : ", 1)
            ]),
            _createVNode("p", null, [
              _createVNode("small", null, _toDisplayString(phase.description ? phase.description : 'N/A'), 1)
            ]),
            (phase.child_phases || phase.tasks)
              ? (_openBlock(), _createBlock("div", _hoisted_70, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.child_phases || phase.groupTasks, (task, taskIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "mb-3 border-bottom pb-3",
                      key: taskIndex
                    }, [
                      _createVNode("div", _hoisted_71, [
                        _createVNode("div", _hoisted_72, [
                          _createVNode("div", _hoisted_73, [
                            _createVNode("label", {
                              for: "",
                              title: _ctx.$t('phase_name')
                            }, _toDisplayString(task.name), 9, ["title"])
                          ])
                        ]),
                        (task.allMembers)
                          ? (_openBlock(), _createBlock("div", _hoisted_74, [
                              _createVNode("div", _hoisted_75, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.allMembers, (user, userIndex) => {
                                  return (_openBlock(), _createBlock("a", {
                                    href: "javascript:void(0)",
                                    key: userIndex
                                  }, [
                                    _createVNode("span", null, [
                                      _createVNode("img", {
                                        src: user.image
                                                    ? user.image
                                                    : `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                                                    ,
                                        alt: "user.email",
                                        title: user.email
                                      }, null, 8, ["src", "title"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_76, [
                        _createVNode("div", _hoisted_77, [
                          _createVNode("div", _hoisted_78, [
                            _hoisted_79,
                            _createVNode("div", _hoisted_80, [
                              _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(task.budget), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_81, [
                        _createVNode("div", _hoisted_82, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('task_description')) + ":", 1)
                          ]),
                          _createVNode("p", null, [
                            _createVNode("small", null, _toDisplayString(task.description), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_83, [
                          _createVNode("div", _hoisted_84, [
                            _createVNode("div", _hoisted_85, [
                              _hoisted_86,
                              _createVNode("p", null, [
                                _createVNode("small", null, _toDisplayString(_ctx.calculateTaskDays(task.time_line)), 1)
                              ])
                            ])
                          ])
                        ]),
                        (['2', '3'].includes(task.time_line.type))
                          ? (_openBlock(), _createBlock("div", _hoisted_87, [
                              _createVNode("div", _hoisted_88, [
                                _createVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: "excludeWeekends",
                                  checked: task.time_line.excludeWeekends === 1,
                                  disabled: ""
                                }, null, 8, ["checked"]),
                                _hoisted_89
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_90, [
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('item_lists')) + " :", 1)
                        ]),
                        (task.items && task.items.length > 0 || task.estimation_items)
                          ? (_openBlock(), _createBlock("div", _hoisted_91, [
                              _createVNode("div", _hoisted_92, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.items || task.estimation_items, (item, itemIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "card p-1",
                                    key: itemIndex
                                  }, [
                                    _createVNode("div", {
                                      class: "card-header p-0",
                                      id: `heading${itemIndex}${taskIndex}`
                                    }, [
                                      _createVNode("h2", _hoisted_93, [
                                        _createVNode("button", {
                                          class: "btn btn-link text-left shadow-none collapsed",
                                          type: "button",
                                          "data-toggle": "collapse",
                                          "data-target": `#collapse${itemIndex}${taskIndex}`,
                                          "aria-expanded": "true",
                                          "aria-controls": "collapseOne"
                                        }, _toDisplayString(item.name), 9, ["data-target"])
                                      ])
                                    ], 8, ["id"]),
                                    _createVNode("div", {
                                      id: `collapse${itemIndex}${taskIndex}`,
                                      class: "collapse",
                                      "aria-labelledby": "headingOne",
                                      "data-parent": "#accordionExample"
                                    }, [
                                      _createVNode("div", _hoisted_94, [
                                        _createVNode("div", _hoisted_95, [
                                          _createVNode("div", _hoisted_96, [
                                            _createVNode("p", null, [
                                              _createVNode("strong", null, _toDisplayString(_ctx.$t('item_name')), 1)
                                            ]),
                                            _createVNode("p", null, _toDisplayString(item.name), 1),
                                            _createVNode("p", null, [
                                              _createVNode("strong", null, _toDisplayString(_ctx.$t('item_cost')), 1)
                                            ]),
                                            _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(item.cost)), 1),
                                            _createVNode("p", null, [
                                              _createVNode("strong", null, _toDisplayString(_ctx.$t('quantity')), 1)
                                            ]),
                                            _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                          ]),
                                          _createVNode("div", _hoisted_97, [
                                            _createVNode("p", null, [
                                              _createVNode("strong", null, _toDisplayString(_ctx.$t('mark_up')), 1)
                                            ]),
                                            _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(item.markup, item.markup_type)), 1),
                                            _createVNode("p", null, [
                                              _createVNode("strong", null, _toDisplayString(_ctx.$t('item_description')), 1)
                                            ]),
                                            _createVNode("p", null, _toDisplayString(item.description), 1)
                                          ])
                                        ])
                                      ])
                                    ], 8, ["id"])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (phase.attachments &&
                        phase.attachments.length
                    )
              ? (_openBlock(), _createBlock("p", _hoisted_98, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_attachments')) + " : ", 1)
                ]))
              : _createCommentVNode("", true),
            (phase.attachments &&
                        phase.attachments.length
                    )
              ? (_openBlock(), _createBlock("div", _hoisted_99, [
                  _createVNode("div", _hoisted_100, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.file_type === 'jpg' ||
                                    image.file_type === 'png' ||
                                    image.file_type === 'jpeg' ||
                                    image.file_type === 'jpg' ||
                                    image.file_type === 'gif'
                                )
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: "shadowed-card bg-white mb-2",
                              onClick: ($event: any) => (_ctx.handleImageInNewTab(image.file_link)),
                              style: {"cursor":"pointer"}
                            }, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_101, [
                                    _createVNode("span", _hoisted_102, [
                                      _createVNode("span", _hoisted_103, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_104, [
                                _createVNode("div", _hoisted_105, [
                                  _createVNode("img", {
                                    src: image.file_link,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'pdf')
                          ? (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "shadowed-card bg-white mb-2",
                              onClick: ($event: any) => (_ctx.handleImageInNewTab(image.file_link)),
                              style: {"cursor":"pointer"}
                            }, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_106, [
                                    _createVNode("span", _hoisted_107, [
                                      _createVNode("span", _hoisted_108, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_109, [
                                _createVNode("div", _hoisted_110, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                                                ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                                                : 'img/pdf.jpg'
                                                ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'doc' || image.file_type === 'docx')
                          ? (_openBlock(), _createBlock("div", {
                              key: 2,
                              class: "shadowed-card bg-white mb-2",
                              onClick: ($event: any) => (_ctx.handleImageInNewTab(image.file_link)),
                              style: {"cursor":"pointer"}
                            }, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_111, [
                                    _createVNode("span", _hoisted_112, [
                                      _createVNode("span", _hoisted_113, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_114, [
                                _hoisted_115,
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'mp4' ||
                                    image.file_type === 'mov' ||
                                    image.file_type === 'MOV' ||
                                    image.file_type === 'wmv' ||
                                    image.file_type === 'webm' ||
                                    image.file_type === 'ogg' ||
                                    image.file_type === 'avi' ||
                                    image.file_type === 'x-ms-wmv'
                                )
                          ? (_openBlock(), _createBlock("div", {
                              key: 3,
                              class: "media-wrap shadowed-card bg-white mb-2",
                              onClick: ($event: any) => (_ctx.handleImageInNewTab(image.file_link)),
                              style: {"cursor":"pointer"}
                            }, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_116, [
                                    _createVNode("div", _hoisted_117, [
                                      _createVNode("span", _hoisted_118, [
                                        _createVNode("span", _hoisted_119, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                                        ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                                        : 'img/video-icon.png'
                                        ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      (_ctx.state.data.smartContractDtail.attachments && _ctx.state.data.smartContractDtail.attachments.length > 0)
        ? (_openBlock(), _createBlock("p", _hoisted_120, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('attachments')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_121, [
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.smartContractDtail.attachments, (file, fileIndex) => {
            return (_openBlock(), _createBlock("li", { key: fileIndex }, [
              _createVNode("div", {
                class: "shadowed-card bg-white",
                onClick: ($event: any) => (_ctx.handleImageInNewTab(file.file_link)),
                style: {"cursor":"pointer"}
              }, [
                _createVNode("div", _hoisted_122, [
                  _createVNode("div", _hoisted_123, [
                    _createVNode("div", _hoisted_124, [
                      _createVNode("img", {
                        src: _ctx.state.data.imageBaseUrl + file.file_link,
                        alt: "",
                        height: "150",
                        width: "180"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("div", _hoisted_125, [
                      _createVNode("p", _hoisted_126, _toDisplayString(file.file_name), 1)
                    ])
                  ])
                ])
              ], 8, ["onClick"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_127, [
      _createVNode("div", _hoisted_128, [
        _createVNode("h1", _hoisted_129, _toDisplayString(_ctx.$t('contracts')), 1)
      ]),
      _createVNode("div", _hoisted_130, [
        _createVNode("div", _hoisted_131, [
          _createVNode("div", _hoisted_132, [
            _createVNode("p", _hoisted_133, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('acknowledgement')), 1)
            ]),
            _createVNode("a", _hoisted_134, _toDisplayString(_ctx.$t('view_details')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_135, [
          _createVNode("div", _hoisted_136, [
            _createVNode("p", _hoisted_137, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('legal_statement')), 1)
            ]),
            _createVNode("a", _hoisted_138, _toDisplayString(_ctx.$t('view_details')), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_139, [
      _createVNode("div", _hoisted_140, [
        _createVNode("h1", _hoisted_141, _toDisplayString(_ctx.$t('signatures')), 1)
      ]),
      _createVNode("div", _hoisted_142, [
        (_ctx.state.data.smartContractDtail.signature)
          ? (_openBlock(), _createBlock("div", _hoisted_143, [
              _createVNode("div", _hoisted_144, [
                _createVNode("img", {
                  src: _ctx.state.data.smartContractDtail.signature,
                  alt: ""
                }, null, 8, ["src"])
              ]),
              _createVNode("p", null, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('sender')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.state.data.smartContractDtail.user.full_name), 1)
              ]),
              _createVNode("p", null, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                _createTextVNode(_toDisplayString(_ctx.state.data.smartContractDtail.signature_date), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.smartContractDtail.singed_customers, (customer, signedCustomerIndex) => {
          return (_openBlock(), _createBlock("div", {
            class: "col-md-4",
            key: signedCustomerIndex
          }, [
            _createVNode("div", _hoisted_145, [
              _createVNode("img", {
                src: customer.signature,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _createVNode("p", null, [
              _createVNode("strong", _hoisted_146, _toDisplayString(_ctx.$t('customer')) + ": ", 1),
              _createTextVNode(_toDisplayString(customer.name ? customer.name :
                        customer.email), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
              _createTextVNode(" " + _toDisplayString(customer.signaute_date), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    (_ctx.state.data.smartContractDtail.pdf_link)
      ? (_openBlock(), _createBlock("div", _hoisted_147, [
          _createVNode("a", {
            href: "javascript:void(0)",
            class: "btn default-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.smartContractDtail.pdf_link)))
          }, [
            _hoisted_148,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_149, [
      _createVNode("div", _hoisted_150, [
        _createVNode("div", _hoisted_151, [
          _createVNode("div", _hoisted_152, [
            _createVNode("div", _hoisted_153, [
              _createVNode("h5", _hoisted_154, _toDisplayString(_ctx.$t('acknowledgement')), 1),
              _hoisted_155
            ]),
            _createVNode("div", _hoisted_156, [
              _createVNode("div", _hoisted_157, [
                _createVNode("div", {
                  innerHTML: _ctx.state.data.smartContractDtail.acknowledgement
                }, null, 8, ["innerHTML"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_158, [
      _createVNode("div", _hoisted_159, [
        _createVNode("div", _hoisted_160, [
          _createVNode("div", _hoisted_161, [
            _createVNode("div", _hoisted_162, [
              _createVNode("h5", _hoisted_163, _toDisplayString(_ctx.$t('legal_statement1')), 1),
              _hoisted_164
            ]),
            _createVNode("div", _hoisted_165, [
              _createVNode("div", _hoisted_166, [
                _createVNode("div", {
                  innerHTML: _ctx.state.data.smartContractDtail.legal_statement
                }, null, 8, ["innerHTML"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}